import {
	CanvasTexture,
	ClampToEdgeWrapping,
	CustomBlending,
	LinearFilter,
	Object3D,
	Sprite,
	SpriteMaterial,
	Vector3
} from 'three'

const FONT_SIZE = 80
const SCALE = 0.1
const FONT_FAMILY = 'BrownPro-Light, sans-serif'
const LINE_HEIGHT = 1
const PADDING = FONT_SIZE * 0.1
const WIDTH = 40
const HEIGHT = Math.floor(WIDTH * 0.6667)

export default class Label {
	private readonly center: Vector3
	private readonly object: Object3D = new Object3D()

	public readonly id: string
	public readonly position: Vector3
	public readonly label: Sprite
	public readonly icon: Sprite

	constructor(id, text, parent, position, iconTexture) {
		this.id = id
		this.position = position
		this.center = new Vector3()

		const canvas = document.createElement('canvas')
		const ctx = canvas.getContext('2d')
		ctx.font = `${FONT_SIZE}px ${FONT_FAMILY}`

		const textArray = text.toUpperCase().split('\n')

		const baseHeight = textArray.length * LINE_HEIGHT * FONT_SIZE + PADDING * 2
		let baseWidth = 0

		textArray.forEach((text) => {
			const { width } = ctx.measureText(text)
			if (width > baseWidth) {
				baseWidth = width + PADDING * 2
			}
		})

		canvas.width = baseWidth
		canvas.height = baseHeight

		ctx.textAlign = 'center'
		ctx.fillStyle = 'white'

		textArray.forEach((text, index) => {
			const y = (index + 1) * LINE_HEIGHT * FONT_SIZE
			ctx.font = `${FONT_SIZE}px ${FONT_FAMILY}`
			ctx.fillText(text, baseWidth * 0.5, y)
		})

		const texture = new CanvasTexture(canvas)
		texture.generateMipmaps = false
		texture.wrapS = texture.wrapT = ClampToEdgeWrapping
		texture.minFilter = LinearFilter
		texture.premultiplyAlpha = true

		this.object.position.copy(position)

		this.label = new Sprite(
			new SpriteMaterial({
				map: texture,
				opacity: 1,
				depthWrite: false,
				depthTest: false,
				blending: CustomBlending
			})
		)

		this.label.userData.id = this.id
		this.label.center.y = 1 + (FONT_SIZE / baseHeight) * 0.5
		this.label.scale.set(SCALE * baseWidth, SCALE * baseHeight, 1)

		this.icon = new Sprite(
			new SpriteMaterial({
				map: iconTexture,
				depthWrite: false,
				depthTest: false,
				blending: CustomBlending
			})
		)
		this.icon.userData.id = this.id

		this.icon.scale.set(WIDTH * SCALE * 2, HEIGHT * SCALE * 2, 1)
		this.object.add(this.icon)
		this.object.add(this.label)
		parent.add(this.object)
	}

	setInactive() {
		this.label.material.opacity = 0.5
		this.icon.material.opacity = 0.5
	}

	setActive() {
		this.label.material.opacity = 1
		this.icon.material.opacity = 1
	}

	update(elapsed) {
		this.label.material.opacity = elapsed
		this.icon.material.opacity = elapsed
		this.object.position.lerpVectors(this.center, this.position, elapsed)
	}
}
